import { z } from "zod";

export const schema = z.object({
  name: z.string().optional(),
  email: z.string().email(),
  company: z.string().optional(),
  interestedModes: z.array(z.string()).optional(),
  expectedUsage: z.string().optional(),
});

export type FormSchema = z.infer<typeof schema>;
